import {
  getDrafts,
  saveDraft,
  getDraft,
  deleteDraft,
  saveFile,
  uploadDone,
  editDraft,
  saveTl
} from 'api/drafts';
import { useMutation } from 'react-query';

function useGetDrafts() {
  return useMutation(getDrafts, {
    onError: (err) => {
      console.log(err.message);
    },
  })
};

function useSaveDraft() {
  return useMutation(saveDraft, {
    onError: (err) => {
      console.log(err.message);
    },
  })
};

function useEditDraft() {
  return useMutation(editDraft, {
    onError: (err) => {
      console.log(err.message);
    },
  })
};

function useGetDraft() {
  return useMutation(getDraft, {
    onError: (err) => {
      console.log(err.message);
    },
  })
};

function useDeleteDraft() {
  return useMutation(deleteDraft, {
    onError: (err) => {
      console.log(err.message);
    },
  })
};

function useSaveFile() {
  return useMutation(saveFile, {
    onError: (err) => {
      console.log(err.message);
    },
  })
};

function useUploadDone() {
  return useMutation(uploadDone, {
    onError: (err) => {
      console.log(err.message);
    },
  })
};

function useSaveTl() {
  return useMutation(saveTl, {
    onError: (err) => {
      console.log(err.message);
    },
  })
};

export {
  useGetDrafts,
  useSaveDraft,
  useGetDraft,
  useDeleteDraft,
  useSaveFile,
  useUploadDone,
  useEditDraft,
  useSaveTl,
};

